import Vue from 'vue';
import VueMultianalytics from 'vue-multianalytics';
import store from '@/store';
import analyticsMixin from '@/services/analyticsMixin.js';

export default {
  setup() {
    Vue.use(
      VueMultianalytics,
      {
        modules: {
          ga: {
            appName: 'Site', // Mandatory
            appVersion: store.state.appVersion, // Mandatory
            trackingId: store.state.citySelected.googleAnalyticsMeasurementId, // Mandatory
            globalDimensions: [],
            globalMetrics: [],
            debug: process.env.NODE_ENV === 'development'
          }
        }
      },
      analyticsMixin
    );
  }
};
